export default {"src":"/_next/static/media/bookmark-o-theme-icon.98ea1c96.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};